<div *ngIf="isLoaded">
  <div *ngIf="taskStatus && ['New', 'Rejected'].includes(taskStatus); else OtherContact">
    <tsl-alert *ngIf="contextVerbiage" icon="info_blue" style="color: #3E6AE1" status="primary">{{
      translate.get(contextVerbiage.diversity.description) }}</tsl-alert>
    <diversity-edit #diversityEdit [tsl-supplierDiversity]="supplierDiversity"></diversity-edit>
    <button *ngIf="!isSidePanelMode" class="action-btn" tsl-button size="small" color="blue" filled (click)="onSubmit()"
      i18n="@@Submit" t="Submit">Submit</button>
  </div>
  <ng-template #OtherContact>
    <h3>
      <span i18n="@@taskCompleteRedirect" t="taskCompleteRedirect">Task is already completed please go back to home
        page.</span>
      <a i18n="@@clickHere" t="clickHere" href="javascript:void(0)" (click)="navigateToHome()">Click Here</a>
    </h3>
  </ng-template>
</div>
